import { render, staticRenderFns } from "./legal-notice.vue?vue&type=template&id=a16dadd8&scoped=true"
import script from "./legal-notice.vue?vue&type=script&lang=js"
export * from "./legal-notice.vue?vue&type=script&lang=js"
import style0 from "./legal-notice.vue?vue&type=style&index=0&id=a16dadd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16dadd8",
  null
  
)

export default component.exports